<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Health Record</h1>
        <v-alert type="warning" v-if="selectedEmp.remarks != null">{{
          selectedEmp.remarks
        }}</v-alert>
        <emp-image :empCode="selectedEmp.code"></emp-image>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <emp-lookup
              :class-padding="classPadding"
              v-model="selectedEmp"
              label="Employee Code"
              title="Employee"
              :code-value="true"
              :required="true"
            ></emp-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Name"
              :value="selectedEmp.desc"
              :class="classPadding"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <annual-lookup
              :class-padding="classPadding"
              v-model="selectedAnnual"
              label="Type of Exam"
              title="Annual Physical Exam"
              :required="true"
            ></annual-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <!-- <v-text-field autocomplete="off" label="Date" type="date" :class="classPadding"></v-text-field> -->
            <custom-datepicker
              :class-padding="classPadding"
              label="Date taken"
              v-model="model.date"
              :required="true"
            ></custom-datepicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Result"
              :class="classPadding"
              v-model="model.result"
            >
              <template slot="append">
                <span class="required">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Remarks"
              :class="classPadding"
              v-model="model.remarks"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-file-input
              label="Attachment"
              ref="webLogoReports"
              v-model="attachment"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <dole v-if="isDole"></dole>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="saveDole"
              v-if="isDole && userAccess.add >= 1"
              >Add</v-btn
            >
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="!isDole && userAccess.add >= 1"
              >Add</v-btn
            >
          </v-col>
        </v-row>
        <br />
        <v-divider></v-divider>
        <!-- DOLE Start -->

        <v-row>
          <v-col>
            <dole-list
              :emp-code="selectedEmp.code"
              :key="componentKey"
              v-if="isDole"
            >
              <template slot="actions" slot-scope="{ item }">
                <v-btn
                  @click.stop="edit(item)"
                  text
                  icon
                  v-if="userAccess.edit >= 1"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  @click.stop="deleteItem(item)"
                  text
                  icon
                  v-if="userAccess.delete >= 1"
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <template slot="examType" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEExamType',
                      'Type of Examination'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>
              <!-- Skin -->
              <template slot="skin" slot-scope="{ item }">
                <v-btn
                  @click.stop="viewExamination(item, 'tbl_DOLESkin', 'Skin')"
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Head -->
              <template slot="head" slot-scope="{ item }">
                <v-btn
                  @click.stop="viewExamination(item, 'tbl_DOLEHead', 'Head')"
                  text
                  outlined
                  >View</v-btn
                >
              </template>
              <!-- Eyes -->
              <template slot="eyes" slot-scope="{ item }">
                <v-btn
                  @click.stop="viewExamination(item, 'tbl_DOLEEyes', 'Eyes')"
                  text
                  outlined
                  >View</v-btn
                >
              </template>
              <!-- Mouth -->
              <template slot="mouth" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(item, 'tbl_DOLEMouth', 'Mouth & ENT')
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Respiratory -->
              <template slot="resp" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(item, 'tbl_DOLEResp', 'Respiratory')
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Heart & Blood Vessels -->
              <template slot="heart" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEHeart',
                      'Heart & Blood Vessels'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Gastrointestinal -->
              <template slot="gastro" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(item, 'tbl_DOLEGastro', 'Gastrointestinal')
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>
              <!-- Genito Urinary -->
              <template slot="urinary" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(item, 'tbl_DOLEUrinary', 'Genito Urinary')
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Reproductive  -->
              <template slot="reprod" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(item, 'tbl_DOLEReprod', 'Reproductive')
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Neuromuscular/Skeleal/Joints  -->
              <template slot="skeletal" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLESkeletal',
                      'Neuromuscular/Skeleal/Joints'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Lymphatic and Circulatory  -->
              <template slot="circul" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLECircul',
                      'Lymphatic and Circulatory'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Infectious Diseases  -->
              <template slot="infectD" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEInfectD',
                      'Infectious Diseases'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Diseases Due to Noise and Vibration   -->
              <template slot="dieasNV" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DoleDieasNV',
                      'Diseases Due to Noise and Vibration '
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Diseases Due to Hot Temp   -->
              <template slot="dieasTHHot" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEDieasTHHot',
                      'Diseases Due to Hot Temp'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>
              <!-- Diseases Due to Cold Temp   -->
              <template slot="dieasTHCold" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEDieasTHCold',
                      'Diseases Due to Cold Temp'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Diseases due to Pressure -->
              <template slot="dieasPA" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEDieasPA',
                      'Diseases due to Pressure'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Diseases due to Radiation-->
              <template slot="dieasRad" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEDieasRad',
                      'Diseases due to Radiation'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Accidents/injuries-->
              <template slot="injury" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEInjury',
                      'Accidents/injuries'
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>
              <!-- Immunization Program -->
              <template slot="immune" slot-scope="{ item }">
                <v-btn
                  @click.stop="
                    viewExamination(
                      item,
                      'tbl_DOLEImmune',
                      'Immunization Program '
                    )
                  "
                  text
                  outlined
                  >View</v-btn
                >
              </template>

              <!-- Attachment -->
              <template slot="attachment" slot-scope="{ item }">
                <v-btn @click.stop="viewAttachment(item)" text outlined
                  >View</v-btn
                >
              </template>
            </dole-list>

            <list :emp-code="selectedEmp.code" :key="componentKey" v-else>
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="edit(item)" text icon>
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn @click.stop="deleteItem(item)" text icon>
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <template slot="attachment" slot-scope="{ item }">
                <v-btn @click.stop="viewAttachment(item)" text outlined
                  >View</v-btn
                >
              </template>
            </list>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog v-model="editDialog" width="700" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <annual-lookup
                :class-padding="classPadding"
                v-model="editSelectedAnnual"
                label="Type of Exam"
                title="Annual Physical Exam"
                :required="true"
              ></annual-lookup>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <!-- <v-text-field autocomplete="off" label="Date" type="date" :class="classPadding"></v-text-field> -->
              <custom-datepicker
                :class-padding="classPadding"
                label="Date taken"
                v-model="editModel.date"
                :required="true"
              ></custom-datepicker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Result"
                :class="classPadding"
                v-model="editModel.result"
              >
                <template slot="append">
                  <span class="required">*</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Remarks"
                :class="classPadding"
                v-model="editModel.remarks"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-file-input
                label="Attachment"
                ref="webLogoReports"
                v-model="attachment"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="editDialog = false"
            >Close</v-btn
          >
          <v-btn
            text
            color="success"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewDetails" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">{{ examTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table dense fixed-header>
            <tbody>
              <tr v-for="(item, key) in details" :key="key">
                <td>{{ item.descript }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="viewDetails = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EmpLookup from "../../employee-masterfile/personal-info/Lookup";
import CustomDatepicker from "../../../../components/CustomDatepicker";
import AnnualLookup from "../../../setup/employment-other-info/others/annual-physical-exam/Lookup";
import List from "./List";
import DoleList from "./DoleList";
import { viewFileWithLocation } from "../../../../helpers/utility";
import DOLE from "./DOLE";
import EventBus from "../../../../events/eventBus";
import selectEmpMixin from "../../employee-masterfile/personal-info/mixins/selectEmpMixin";
import EmpImage from "../../employee-masterfile/personal-info/Image";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/healthRecord";
const FOLDER_NAME = "healthRecord";
export default {
  metaInfo: {
    title: "Health Record",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [selectEmpMixin, userAccessMixin],
  data: () => ({
    model: {
      date: new Date().toISOString()
    },
    classPadding: "my-0 py-0",
    selectedEmp: {},
    dateModel: null,
    selectedAnnual: {},
    editSelectedAnnual: {},
    isSaving: false,
    componentKey: 0,
    editModel: {},
    editDialog: false,
    attachment: null,
    attachmentDialog: false,
    attachmentImage: null,
    isUpdating: false,
    reasons: "",
    isDole: false,
    examTypes: [],
    skins: [],
    heads: [],
    eyes: [],
    mouth: [],
    respiratory: [],
    heart: [],
    gastro: [],
    urinary: [],
    reprod: [],
    skeletal: [],
    circul: [],
    infectD: [],
    dieasNV: [],
    dieasTHHot: [],
    dieasTHCold: [],
    dieasPA: [],
    dieasRad: [],
    injury: [],
    immune: [],
    details: [],
    viewDetails: false,
    examTitle: ""
  }),
  components: {
    EmpLookup,
    CustomDatepicker,
    AnnualLookup,
    List,
    Dole: DOLE,
    DoleList,
    EmpImage
  },
  computed: {
    attachmentUrl() {
      if (
        this.attachmentImage == null ||
        typeof this.attachmentImage == "undefined" ||
        this.attachmentImage == ""
      )
        return "";
      else return `data:image/jpeg;base64, ${this.attachmentImage}`;
    }
  },
  methods: {
    save() {
      this.isSaving = true;
      this.model.empCode = this.selectedEmp.code;
      this.model.examType = this.selectedAnnual.code;

      var formData = new FormData();
      var data = Object.assign({}, this.model);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.editDialog = true;
      this.editModel = Object.assign({}, item);
      this.editSelectedAnnual = {
        code: item.examType,
        desc: item.examDesc
      };
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.model = {};
      this.forceRerender();
      this.editDialog = false;
      this.selectedAnnual = {};
      this.model.date = new Date().toISOString();
      this.attachment = null;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      //this.modeel.empCode = this.selectedEmp.code;
      this.editModel.examType = this.editSelectedAnnual.code;

      var formData = new FormData();
      var data = Object.assign({}, this.editModel);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "PUT",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    viewAttachment(item) {
      viewFileWithLocation(
        item.location
      );
    },
    saveDole() {
      this.isSaving = true;
      this.model.empCode = this.selectedEmp.code;
      this.model.examType = this.selectedAnnual.code;
      this.model.dateTaken = this.model.date;
      this.model.results = this.model.result;

      var item = {
        Header: this.model,
        ExamType: this.examTypes,
        Skin: this.skins,
        Head: this.heads,
        Eyes: this.eyes,
        Mouth: this.mouth,
        Resp: this.respiratory,
        Heart: this.heart,
        Gastro: this.gastro,
        Urinary: this.urinary,
        Reprod: this.reprod,
        Skeletal: this.skeletal,
        Circul: this.circul,
        InfectD: this.infectD,
        DieasNV: this.dieasNV,
        DieasTHHot: this.dieasTHHot,
        DieasTHCold: this.dieasTHCold,
        DieasPA: this.dieasPA,
        DieasRad: this.dieasRad,
        Injury: this.injury,
        immune: this.immune
      };

      var formData = new FormData();
      formData.append("json", JSON.stringify(item));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}/dole`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    viewExamination(item, tableName, title) {
      this.examTitle = title;
      this.viewDetails = true;
      this.$axios
        .get(`${API_ENDPOINT}/dole/${item.id}/${tableName}`)
        .then(({ data }) => {
          this.details = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  watch: {
    selectedEmp() {
      this.forceRerender();
    },
    selectedAnnual(val) {
      if (val.code == "DOLE") {
        setTimeout(() => {
          this.isDole = true;
        }, 500);
      } else {
        setTimeout(() => {
          this.isDole = false;
        }, 500);
      }
    }
  },
  created() {
    this.getUserAccessRights("EMFOIHRM");
  },
  mounted() {
    EventBus.$on("tbl_DOLEExamType", val => {
      this.examTypes = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLESkin", val => {
      this.skins = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEHead", val => {
      this.heads = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEEyes", val => {
      this.eyes = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEMouth", val => {
      this.mouth = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEResp", val => {
      this.respiratory = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEHeart", val => {
      this.heart = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEGastro", val => {
      this.gastro = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEUrinary", val => {
      this.urinary = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEReprod", val => {
      this.reprod = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLESkeletal", val => {
      this.skeletal = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLECircul", val => {
      this.circul = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEInfectD", val => {
      this.infectD = Object.assign([], val);
    });

    EventBus.$on("tbl_DoleDieasNV", val => {
      this.dieasNV = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEDieasTHHot", val => {
      this.dieasTHHot = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEDieasTHCold", val => {
      this.dieasTHCold = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEDieasPA", val => {
      this.dieasPA = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEDieasRad", val => {
      this.dieasRad = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEInjury", val => {
      this.injury = Object.assign([], val);
    });

    EventBus.$on("tbl_DOLEImmune", val => {
      this.immune = Object.assign([], val);
    });

    EventBus.$on("REASONS", val => {
      this.model.reason = val;
    });
  }
};
</script>